<h2 class="mt-5">{{cardConfiguration.title}}</h2>

<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <label for="IrsTable"><span class="mandatory">*</span>{{'CardSubscriberFiscalInfo.IrsTable' | translate}}</label>
      <select class="custom-select" [(ngModel)]="cardData.irsTableCode" name="irsTableCode" #irsTableCode="ngModel" required
              [clearRelated]="{model : this.cardData , propsToReset : ['devalorizationPercentage']} "
              [dropdownTitle]="{value : cardData.irsTableCode , dimensions :  fiscalCategories }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of fiscalCategories" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="irsTableCode"></validation-message>
    </div>
  </div>

  <!-- Need to replace by the correct code of irsTableCode == 'Defeciente'-->
  <div class="col-sm-4">
    <div class="form-group">
      <label [ngClass]="cardData.irsTableCode != 'DEF' ? 'disabled' : '' " for="DevalorizationPercentage"><span class="mandatory" *ngIf="cardData.irsTableCode == 'DEF'">*</span>{{'CardSubscriberFiscalInfo.DevalorizationPercentage' | translate}}</label>
      <div class="position-relative">
        <input class="form-control input-right" type="text" percentage [(ngModel)]="cardData.devalorizationPercentage" #devalorizationPercentage="ngModel" name="devalorizationPercentage"
             minValue="0" maxValue="100" maxlength="6"
             placeholder="{{'Placeholders.Generic.Percentage' | translate}}"
             [disabled]="cardData.irsTableCode != 'DEF'" [required]="cardData.irsTableCode == 'DEF'" messageFieldType="percentage">
      <span class="input-icon-span-right">%</span>
      <validation-message [control]="devalorizationPercentage"></validation-message>
      </div>
    </div>
  </div>

  <div class="col-sm-4">
    <div class="form-group">
      <label for="RevenueTitularity"><span class="mandatory">*</span>{{'CardSubscriberFiscalInfo.RevenueTitularity' | translate}}</label>
      <select class="custom-select" [(ngModel)]="cardData.revenueTitularityCode" name="revenueTitularityCode" #revenueTitularityCode="ngModel" required
              [dropdownTitle]="{value : cardData.revenueTitularityCode, dimensions : incomeHoldings }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of getOrderedIncomeHoldings()" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="revenueTitularityCode"></validation-message>
    </div>
  </div>

  <div class="col-sm-4">
    <div class="form-group">
      <label for="FullTaxOption">
        {{'CardSubscriberFiscalInfo.FullTaxOption' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberFiscalInfo.FullTaxOption' | translate}}"></span>
      </label>
      <div class="position-relative">
        <input class="form-control" type="text" percentage maxlength="5"
               placeholder="{{'Placeholders.CardSubscriberFiscalInfo.FullTaxOption' | translate}}"
               [(ngModel)]="cardData.fullTaxOption" #fullTaxOption="ngModel" name="fullTaxOption" minValue="0" maxValue="40" messageFieldType="percentage">
        <span class="input-icon-span-right">%</span>
      </div>
      <validation-message [control]="fullTaxOption"></validation-message>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-sm-12">
    <h3>
      {{'CardSubscriberFiscalInfo.NumberOfDependents.Title' | translate}}
    </h3>
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="WithoutDisability">
        <span class="mandatory">*</span>{{'CardSubscriberFiscalInfo.NumberOfDependents.WithoutDisability' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberFiscalInfo.NumberOfDependents.WithoutDisability' | translate}}"></span>
      </label>
      <div class="position-relative">
        <input class="form-control input-right" type="text" numeric="2"
               placeholder="{{'Placeholders.CardSubscriberFiscalInfo.NumberOfDependents.WithoutDisability' | translate}}"
               [(ngModel)]="cardData.dependentCountWithoutDisability" #dependentCountWithoutDisability="ngModel" name="dependentCountWithoutDisability" required maxValue="10">
        <validation-message [control]="dependentCountWithoutDisability"></validation-message>
      </div>
    </div>
  </div>

  <div *ngIf="isVersion2()" class="col-sm-4">
    <div class="form-group">
      <label for="WithDisability">
        <span class="mandatory">*</span>{{'CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}"></span>
      </label>
      <div class="position-relative">
        <input class="form-control input-right" type="text" numeric="1" maxlength="2"
               placeholder="{{'Placeholders.CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}"
               [(ngModel)]="cardData.dependentCountWithDisability" #dependentCountWithDisability="ngModel" name="dependentCountWithtDisability"
               maxValue="5" required>
        <validation-message [control]="dependentCountWithDisability"></validation-message>
      </div>
    </div>
  </div>

  <div *ngIf="!isVersion2()" class="col-sm-4">
    <div class="form-group">
      <label for="WithDisability">
        <span class="mandatory">*</span>{{'CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}"></span>
      </label>
      <div class="position-relative">
        <input class="form-control input-right" type="text" numeric="1" maxlength="2"
               placeholder="{{'Placeholders.CardSubscriberFiscalInfo.NumberOfDependents.WithDisability' | translate}}"
               [(ngModel)]="cardData.dependentCountWithDisability" #dependentCountWithDisability="ngModel" name="dependentCountWithtDisability" maxValue="5" required>
        <validation-message [control]="dependentCountWithDisability"></validation-message>
      </div>
    </div>
  </div>
</div>

<!-- <pre>{{cardData | json}}</pre> -->
